'use client';

var EMaritalStatus;
(function (EMaritalStatus) {
    EMaritalStatus[EMaritalStatus["NEW"] = 0] = "NEW";
    EMaritalStatus[EMaritalStatus["SINGLE"] = 1] = "SINGLE";
    EMaritalStatus[EMaritalStatus["MARRIED"] = 2] = "MARRIED";
})(EMaritalStatus || (EMaritalStatus = {}));
var EGender;
(function (EGender) {
    EGender[EGender["MALE"] = 1] = "MALE";
    EGender[EGender["FEMALE"] = 2] = "FEMALE";
})(EGender || (EGender = {}));
var ETab;
(function (ETab) {
    ETab[ETab["UPLOAD_CV"] = 1] = "UPLOAD_CV";
    ETab[ETab["CONTACT_INFORMATION"] = 2] = "CONTACT_INFORMATION";
    ETab[ETab["WORKING_PREFERENCE"] = 3] = "WORKING_PREFERENCE";
})(ETab || (ETab = {}));

export { EGender, EMaritalStatus, ETab };
//# sourceMappingURL=type.js.map
